/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMcpVaultGetServer } from "../../funcs/llmMcpVaultGetServer.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetMcpServerRequest$inboundSchema,
};

export const tool$llmMcpVaultGetServer: ToolDefinition<typeof args> = {
  name: "llm-mcp-vault-get-server",
  description: `Retrieve MCP server

Returns a user-owned MCP server configuration.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMcpVaultGetServer(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
